var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('exc-loader',{staticClass:"txt--main"}):_c('div',_vm._l((_vm.faqItems),function(group,i){return _c('welcome-faq-block',{key:group.id || ("key_" + i),attrs:{"posts":group.posts}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }